export const DAYS = [
  `Sunday`,
  `Monday`,
  `Tuesday`,
  `Wednesday`,
  `Thursday`,
  `Friday`,
  `Saturday`,
] as const;

export const DAYS_SHORT = [
  `Sun`,
  `Mon`,
  `Tues`,
  `Wed`,
  `Thur`,
  `Fri`,
  `Sat`,
] as const;

export const MONTHS = [
  `January`,
  `February`,
  `March`,
  `April`,
  `May`,
  `June`,
  `July`,
  `August`,
  `September`,
  `October`,
  `November`,
  `December`,
] as const;

export const MONTHS_SHORT = [
  `Jan`,
  `Feb`,
  `Mar`,
  `Apr`,
  `May`,
  `Jun`,
  `Jul`,
  `Aug`,
  `Sep`,
  `Oct`,
  `Nov`,
  `Dec`,
] as const;
